var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.66671H12C11.6463 4.66671 11.3072 4.52623 11.0572 4.27618C10.8071 4.02613 10.6666 3.687 10.6666 3.33337V1.33337",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.00004V8.33337C14 8.86671 13.5334 9.33337 13 9.33337H8.33337C7.80004 9.33337 7.33337 8.86671 7.33337 8.33337V2.33337C7.33337 1.80004 7.80004 1.33337 8.33337 1.33337H11.3334L14 4.00004Z",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 5.33337V11.2C4.66663 11.4 4.79996 11.6 4.93329 11.7334C5.06663 11.8667 5.26663 12 5.46663 12H9.99996",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8V13.8667C2 14.0667 2.13333 14.2667 2.26667 14.4C2.4 14.5333 2.6 14.6667 2.8 14.6667H7.33333",
    stroke: "#4B5563",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecords);
export default __webpack_public_path__ + "static/media/records.b5dcd02ad0d0ecd37353c6b36d4ae66b.svg";
export { ForwardRef as ReactComponent };